function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 15.874,
    height: 15.874,
    viewBox: "0 0 36.51 36.51"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M33.245 12.397a2.3 2.3 0 0 0-1.844-1.51l-8.326-1.239-3.619-7.514A2.32 2.32 0 0 0 17.364.84c-.896 0-1.71.505-2.092 1.294l-3.619 7.514-8.327 1.238a2.3 2.3 0 0 0-1.842 1.511 2.21 2.21 0 0 0 .537 2.285l6.102 6.092-1.415 8.451a2.22 2.22 0 0 0 .948 2.203 2.35 2.35 0 0 0 2.45.131l7.258-3.908 7.26 3.908a2.37 2.37 0 0 0 2.45-.13 2.23 2.23 0 0 0 .946-2.204l-1.416-8.45 6.104-6.093c.603-.603.81-1.485.537-2.285m-8.293 6.806a2.22 2.22 0 0 0-.627 1.934l1.416 8.451-7.26-3.906a2.361 2.361 0 0 0-2.235 0l-7.26 3.906 1.416-8.45a2.21 2.21 0 0 0-.626-1.935l-6.102-6.092L12 11.871a2.3 2.3 0 0 0 1.743-1.268l3.621-7.512 3.62 7.513a2.31 2.31 0 0 0 1.742 1.268l8.328 1.24z",
    style: {
      fill: "#f5cb51",
      fillOpacity: 1
    }
  }));
};
export default SvgStar;